<!-- 中继详情 -->
<template>
    <relayDetailWin :detailObj="detailObj" :deviceProperty="deviceProperty" v-bind="$attrs" ref="detailDialog"
        :detailNetObj="netObj" :deviceType="deviceType"></relayDetailWin>
</template>

<script>
import relayDetailWin from "./component/relayDetailWin.vue";
import { relayDetailInfo } from "@/api/modules/relay";
export default {
    components: {
        relayDetailWin
    },
    data() {
        return {
            detailObj: {},
            deviceProperty: {},
            netObj: {},
            deviceType: {},
        }
    },
    methods: {
        detailFn(id) {
            relayDetailInfo(id).then(({ result }) => {
                const url = `${result.relay.fullPath}/${result.relay.carrierName}`
                this.detailObj = Object.assign({}, { ...result.relay }, { url })
                this.netObj = Object.assign({}, { ...result.netConfig });
                this.deviceType = result.deviceType;
                this.deviceProperty = result.deviceProperty || {};
            })
        },
    },
    mounted() {
        if (this.$route.query && this.$route.query.id) {
            const { id } = this.$route.query
            this.detailFn(id);
        }
    },

}
</script>

<style>
</style>